import React from 'react'
import {useTranslation} from 'react-i18next'
import {Form, Radio, Tooltip} from 'antd'
import {IconTitle} from '@/components'
import {
    ORDER_NUMBER_OPTIONS,
    ORDER_NUMBER_OPTION_TRANSLATION_KEYS
} from './constants'

import styles from './styles.scss'

export const OrderNumberOptionsField: React.FC = () => {
    const {t} = useTranslation()

    return (
        <Form.Item
            name='paymentReferenceMode'
            label={
                <IconTitle
                    title={t('OrderNumberOptions.labels.title')}
                    tooltipText={
                        <span className={styles.mainTooltip}>
                            {t('OrderNumberOptions.tooltips.main')}
                        </span>
                    }
                />
            }
        >
            <Radio.Group className={styles.options}>
                {ORDER_NUMBER_OPTIONS.map((option) => {
                    const translationKey = ORDER_NUMBER_OPTION_TRANSLATION_KEYS[option]

                    return (
                        <Tooltip
                            key={option}
                            title={t(`OrderNumberOptions.tooltips.${translationKey}`)}
                        >
                            <Radio.Button
                                className={styles[translationKey]}
                                value={option}
                            >
                                {t(`OrderNumberOptions.labels.${translationKey}`)}
                            </Radio.Button>
                        </Tooltip>
                    )
                })}
            </Radio.Group>
        </Form.Item>
    )
}
